export const localStorageKeys = {
  history: "plungeHistory",
}
